module.exports = __webpack_public_path__ + "static/media/tommySleeveHood4.39c18f11.svg";